{
  "header": {
    "title": "Aperçu de l'enquête",
    "description": "Créez, gérez et analysez les enquêtes auprès des employés pour obtenir des informations approfondies",
    "createButton": "Créer une enquête",
    "createModal": {
      "title": "Créer une enquête",
      "useTemplate": {
        "title": "Utiliser des modèles",
        "description": "Découvrez des modèles préconçus et personnalisez-les selon vos objectifs",
        "buttonLabel": "Voir les modèles"
      },
      "createTemplate": {
        "title": "Créer à partir de zéro",
        "description": "Créez votre enquête unique avec le format que vous préférez",
        "buttonLabel": "Créer l'enquête"
      }
    },
    "unsavedChangesDialog": {
      "title": "Modifications non enregistrées de l'enquête",
      "description": "Vous avez des modifications non enregistrées qui seront perdues si vous quittez cette page. Voulez-vous continuer sans enregistrer ?",
      "exitButton": "Quitter sans enregistrer",
      "keepEditingButton": "Continuer la modification"
    }
  },
  "tabs": {
    "active": "Actif",
    "finished": "Terminé",
    "scheduled": "Planifié",
    "drafts": "Brouillons"
  },
  "searchInput": {
    "placeholder": "Rechercher des enquêtes"
  },
  "tagsDropdown": {
    "triggerLabel": "Tags",
    "placeholder": "Trouver un tag",
    "options": {
      "employeeEngagement": "Engagement des employés",
      "workplaceCulture": "Culture d'entreprise",
      "teamSatisfaction": "Satisfaction de l'équipe",
      "performanceFeedback": "Retour sur la performance",
      "organizationalImprovement": "Amélioration organisationnelle",
      "usa": "États-Unis",
      "europe": "Europe",
      "asia": "Asie",
      "ukraine": "Ukraine"
    }
  },
  "builderPage": {
    "header": {
      "title": "Créateur d'enquête",
      "backButton": "Retour",
      "seePreviewButton": "Voir l'aperçu",
      "shareButton": "Partager",
      "saveButton": {
        "label": "Enregistrer",
        "options": {
          "draft": "Enregistrer comme brouillon",
          "template": "Enregistrer comme modèle",
          "companyTemplate": "Enregistrer comme modèle d'entreprise"
        }
      },
      "publishButton": "Publier"
    },
    "tabs": {
      "surveySetup": {
        "title": "Configuration de l'enquête",
        "coverImageSection": {
          "title": "Image de couverture",
          "imageUpload": "Téléchargez une image ou déposez-la ici",
          "imageSize": "Max. 800x400 px",
          "formatImage": "Format PNG, JPG",
          "titleInput": {
            "label": "Titre de l'enquête",
            "placeholder": "Entrez un titre"
          },
          "descriptionInput": {
            "label": "Description de l'enquête",
            "placeholder": "Entrez une description"
          },
          "tagsInput": {
            "label": "Tags de l'enquête",
            "placeholder": "Entrez un tag et appuyez sur Entrée"
          }
        },
        "question": {
          "title": "Question #{{questionCount}}",
          "required": "Requis",
          "type": {
            "title": "Type de question",
            "textType": "Texte",
            "scaleType": "Échelle",
            "choiceType": "Choix"
          },
          "questionInput": {
            "label": "Question",
            "placeholder": "Entrez la question ici"
          },
          "descriptionInput": {
            "label": "Description de la question",
            "placeholder": "Entrez la description ici"
          },
          "span": {
            "title": "Étendue",
            "to": "à"
          },
          "spanLabels": {
            "title": "Étiquettes d'étendue",
            "placeholder": "Étiquette (optionnel)"
          },
          "options": {
            "title": "Options de choix",
            "placeholder": "Entrez un choix",
            "addChoiceButton": "Ajouter un choix",
            "multipleAnswers": "Réponses multiples"
          },
          "addNewQuestionBUtton": "Ajouter une nouvelle question"
        },
        "cardPreview": {
          "title": "Aperçu de la carte d'enquête",
          "tabs": {
            "cover": {
              "label": "Couverture",
              "time": "1-2 minutes"
            },
            "template": {
              "label": "Modèle",
              "time": "1-2 minutes"
            }
          }
        }
      },
      "audience": {
        "title": "Public",
        "audienceSection": {
          "title": "Taille du public"
        },
        "surveyAudienceSection": {
          "title": "Public de l'enquête",
          "options": {
            "entireCompany": "Toute l'entreprise"
          }
        },
        "segmentationSection": {
          "title": "Options de segmentation",
          "selectAll": "Tout sélectionner",
          "options": {
            "location": {
              "label": "Emplacement",
              "options": {
                "us": "États-Unis",
                "europe": "Europe",
                "asia": "Asie"
              }
            },
            "department": {
              "label": "Département",
              "options": {
                "executiveTeam": "Équipe de direction",
                "technicalTeam": "Équipe technique",
                "designTeam": "Équipe design",
                "productTeam": "Équipe produit",
                "salesTeam": "Équipe commerciale",
                "marketingTeam": "Équipe marketing",
                "financeTeam": "Équipe financière"
              }
            },
            "gender": {
              "label": "Genre",
              "options": {
                "male": "Homme",
                "female": "Femme"
              }
            },
            "tenure": {
              "label": "Ancienneté",
              "options": {
                "lessThanHalf": "<0,5 ans",
                "halfToOne": "0,5–1 an",
                "oneToTwo": "1–2 ans",
                "twoToFive": "2–5 ans",
                "moreThanFive": "5+ ans"
              }
            }
          }
        },
        "distributionSection": {
          "title": "Méthodes de distribution",
          "options": {
            "mail": "Email automatisé",
            "link": "Partage manuel du lien"
          }
        }
      },
      "delivery": {
        "title": "Livraison",
        "startDate": {
          "label": "Date de début",
          "placeholder": "Sélectionnez la date"
        },
        "endDate": {
          "label": "Date de fin",
          "closeAfter": "Fermer après",
          "days": "jours",
          "closeButton": "Ne pas fermer automatiquement"
        }
      },
      "translation": {
        "title": "Traduction",
        "tabs": {
          "info": {
            "label": "Info"
          },
          "question": {
            "label": "Question {{questionCount}}"
          }
        }
      }
    }
  },
  "preview": {
    "header": {
      "backButton": "Aperçu de l'enquête",
      "publishButton": "Publier"
    },
    "question": {
      "finishSurvey": "Terminer le sondage",
      "nextQuestion": "Question suivante",
      "previousQuestion": "Question précédente"
    }
  },
  "detailsPage": {
    "header": {
      "backButton": "Retour à l'aperçu de l'enquête",
      "exportButton": "Exporter"
    },
    "surveyOverviewSection": {
      "title": "Aperçu de l'enquête",
      "invitedBlock": {
        "title": "Invité",
        "usersCount": "{{usersCount}} utilisateurs"
      },
      "responsesBlock": {
        "title": "Réponses"
      },
      "info": {
        "creator": "Créateur",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "segmentation": "Segmentation",
        "distributionMethod": "Méthode de distribution"
      }
    },
    "question": {
      "questionCount": "Question #{{questionCount}}",
      "responseCount": "{{responseCount}} réponses"
    },
    "asnwersSection": {
      "title": "Réponses"
    }
  }
}
